export const TRAVEL_AGENT_ENDPOINT =
  'https://us-central1-lctf-projects.cloudfunctions.net/travelAgentApi';

export const TRAVEL_SEARCH_REQUESTS = 'peopleTravelSearchRequests';
export const TRAVEL_CALENDAR_SYNC_REQUESTS = 'peopleTravelCalendarSyncRequests';
export const TRAVEL_PLAN_REQUESTS = 'peopleTravelPlanRequests';
export const TRAVEL_CHAT_MESSAGES = 'travelAgentChatMessages';

export const TRAVEL_SEARCH_POLL_TIMEOUT_MS = 10 * 60 * 1000;
export const TRAVEL_CALENDAR_SYNC_POLL_TIMEOUT_MS = 5 * 60 * 1000;
/** Cloud planner runs often take 6–10 minutes after the webhook doorbell. */
export const TRAVEL_PLAN_POLL_TIMEOUT_MS = 12 * 60 * 1000;
